import { types } from "../types/types";

const initialState = {
    generales: {},
    turnos: [],
    usuarios: [],
    loading: false
};

export const EstadisticasMiOspedycReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.estadisticasMiOspedycGeneralesTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.estadisticasMiOspedycGeneralesTraerSuccess:
            return {
                ...state,
                generales: action.payload,
                loading: false
            }
        case types.estadisticasMiOspedycGeneralesTraerError:
            return {
                ...state,
                generales: {},
                loading: false
            }
        case types.estadisticasMiOspedycTurnosTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.estadisticasMiOspedycTurnosTraerSuccess:
            return {
                ...state,
                turnos: action.payload,
                loading: false
            }
        case types.estadisticasMiOspedycTurnosTraerError:
            return {
                ...state,
                turnos: [],
                loading: false
            }
        case types.estadisticasMiOspedycUsuariosTraerStart:
            return {
                ...state,
                loading: true
            }
        case types.estadisticasMiOspedycUsuariosTraerSuccess:
            return {
                ...state,
                usuarios: action.payload,
                loading: false
            }
        case types.estadisticasMiOspedycUsuariosTraerError:
            return {
                ...state,
                usuarios: [],
                loading: false
            }
        default:
            return state;
    }
};
